import React from 'react';
import isEmpty from 'lodash/isEmpty';
// eslint-disable-next-line import/no-cycle
import { maxWordLength } from '../util';
import { EMPTY_STRING } from '../../constant/text';

const ToolTip = props => {
    const { value = EMPTY_STRING, maxLength = 0, toolTipText = EMPTY_STRING, icon = null, className = EMPTY_STRING } = props;

    return (
        <div className={`toolTip ${className}`}>
            {maxLength !== 0 && value.length > maxLength ? maxWordLength(value, maxLength) : value}
            {icon}
            {isEmpty(toolTipText) && value.length > maxLength && <span className="toolTipFullText">{value}</span>}
            {!isEmpty(toolTipText) && <span className="toolTipFullText">{toolTipText}</span>}
        </div>
    );
};

export default ToolTip;
